import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { withRouter } from "react-router";

import NavBar from "../components/NavBar";
import "./Login.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div className="background">
        <NavBar />
        <Container maxWidth="xs" style={{ marginTop: "64px" }}>
          <Typography
            variant="h5"
            gutterBottom
            style={{
              color: "#063e6c",
              fontWeight: "900",
              letterSpacing: "1px"
            }}
          >
            Page not found!
          </Typography>
        </Container>
      </div>
    );
  }
}

export default withRouter(Index);
